
import { depListAPI } from '@/api/common';

import WkSelectDropdown from './src/SelectDropdown.vue';
import WkDep from './src/WkDep.vue';

import Emitter from 'element-ui/lib/mixins/emitter';
import { valueEquals } from 'element-ui/lib/utils/util';
import { objDeepCopy } from '@/utils';

export default {
  name: 'WkDepSelect',

  components: {
    WkSelectDropdown: WkSelectDropdown,
    WkDep: WkDep
  },

  mixins: [Emitter],

  props: {
    radio: Boolean,
    // 展示限制
    max: {
      type: Number,
      default: 2
    },
    props: {
      type: Object,
      default: function _default() {
        return {
          value: 'id',
          label: 'name'
        };
      }
    },

    // 选择限制
    limit: Number,
    placeholder: {
      type: String,
      default: function _default() {
        return '请选择';
      }
    },
    // eslint-disable-next-line vue/require-prop-types
    value: {
      required: true
    },
    // 自定义请求和 参数
    request: Function,
    params: Object,
    options: Array,
    disabled: {
      type: Boolean,
      default: false
    },
    popperAppendToBody: {
      type: Boolean,
      default: true
    }
  },

  data: function data() {
    return {
      visible: false,
      dataValue: [], // 校准传入值
      loading: false,
      height: 34,

      optionsList: []
    };
  },


  computed: {
    // 实际展示的数据
    showSelects: function showSelects() {
      if (this.selects && this.selects.length > this.max) {
        return this.selects.slice(0, this.max);
      }
      return this.selects;
    },


    // 选择的数据
    selects: function selects() {
      if (!this.optionsList.length) {
        return [];
      }

      return this.getSelectList();
    }
  },

  watch: {
    visible: function visible(val) {
      if (!val) {
        this.broadcast('WkSelectDropdown', 'destroyPopper');
      } else {
        this.broadcast('WkSelectDropdown', 'updatePopper');
      }
      this.$emit('visible-change', val);
    },
    value: function value() {
      this.verifyValue();
    },


    options: {
      handler: function handler() {
        this.verifyOptions();
      },

      immediate: true
    },

    /**
     * 更新值
     */
    dataValue: function dataValue(newValue, oldValue) {
      if (!valueEquals(newValue, oldValue)) {
        if (this.radio) {
          this.$emit('input', this.dataValue && this.dataValue.length ? this.dataValue[0] : '');
        } else {
          this.$emit('input', this.dataValue);
        }
      }
    },

    showSelects: {
      handler: function handler() {
        this.resetHeight();
      },

      immediate: true
    }
  },

  created: function created() {
    this.verifyValue();
  },


  methods: {
    resetHeight: function resetHeight() {
      var _this = this;

      var tags = this.$refs.tags;
      if (tags) {
        this.$nextTick(function () {
          _this.height = tags.clientHeight > 34 ? tags.clientHeight + 6 : 34;
        });
      } else {
        this.height = 34;
      }
    },


    /**
     * 获取展示的数组
     */
    getSelectList: function getSelectList() {
      var list = [];
      this.recursionOptions(this.optionsList, this.dataValue, list);
      return list;
    },
    recursionOptions: function recursionOptions(options, selects, list) {
      var _this2 = this;

      options.forEach(function (item) {
        if (selects.includes(item[_this2.props.value])) {
          list.push(item);
        }

        if (item.children) {
          _this2.recursionOptions(item.children, selects, list);
        }
      });
    },


    /**
     * 处理值逻辑
     */
    verifyValue: function verifyValue() {
      var _this3 = this;

      // 多选的默认值 校准为数组  单选校准为number
      if (!this.radio && !Array.isArray(this.value)) {
        this.$emit('input', []);
      }

      if (this.radio && (Array.isArray(this.value) || this.value === null || this.value === undefined)) {
        // this.$emit('input', '')
      }

      if (this.radio) {
        if (this.value !== this.dataValue) {
          if (this.value) {
            this.dataValue = [parseInt(this.value)];
          } else {
            this.dataValue = [];
          }
        }
      } else {
        if (!valueEquals(this.value, this.dataValue)) {
          if (this.value && this.value.length) {
            var firstItem = this.value[0];
            if (firstItem[this.props.value]) {
              this.dataValue = this.value.map(function (item) {
                return item[_this3.props.value];
              });
            } else {
              this.dataValue = objDeepCopy(this.value);
            }
          } else {
            this.dataValue = [];
          }
        }
      }
    },


    /**
     * 处理options
     */
    verifyOptions: function verifyOptions() {
      if (!this.options) {
        this.requestDepList();
      } else {
        this.optionsList = this.options;
      }
    },


    /**
     * 获取请求
     */
    requestDepList: function requestDepList() {
      var _this4 = this;

      this.loading = true;
      var request = depListAPI;
      if (this.request) {
        request = this.request;
      } else if (this.props.request) {
        request = this.props.request;
      }

      var params = { type: 'tree' };
      if (this.params) {
        params = this.params;
      }

      request(params).then(function (res) {
        _this4.optionsList = res.data || [];
        _this4.loading = false;
      }).catch(function () {
        _this4.loading = false;
      });
    },
    handleClose: function handleClose() {
      this.visible = false;
    },
    handleMenuEnter: function handleMenuEnter() {
      // 处理聚焦到具体位置
    },
    doDestroy: function doDestroy() {
      this.$refs.popper && this.$refs.popper.doDestroy();
    },


    /**
     * 删除
     */
    deleteDep: function deleteDep(index) {
      if (this.disabled) return;
      // 直接 splice ,dataValue watch 的老旧值相同，复制之后新旧值不相同。暂时解决
      var dataValue = objDeepCopy(this.dataValue);
      dataValue.splice(index, 1);
      this.dataValue = dataValue;
      this.wkDepChange();
    },


    /**
     * 聚焦动作
     */
    focusClick: function focusClick() {
      this.$emit('focus');
    },


    /**
     * chang 事件
     */
    wkDepChange: function wkDepChange() {
      var _this5 = this;

      this.$nextTick(function () {
        if (_this5.radio) {
          _this5.dispatch('ElFormItem', 'el.form.change', _this5.dataValue && _this5.dataValue.length ? _this5.dataValue[0] : '');
          _this5.$emit('input', _this5.dataValue && _this5.dataValue.length ? _this5.dataValue[0] : '');
        } else {
          _this5.dispatch('ElFormItem', 'el.form.change', _this5.dataValue);
          _this5.$emit('input', _this5.dataValue);
        }
        _this5.$emit('change', _this5.dataValue, _this5.selects);
      });
    },
    containerClick: function containerClick() {
      if (!this.disabled) {
        this.visible = true;
      }
    }
  }
};